import {
  FETCH_BRANCH_FAIL,
  FETCH_BRANCH_REQUEST,
  FETCH_BRANCH_SUCCESS,
} from "../../ActionType/BranchType/BranchType";
import { api } from "../../Api/api";
import { getToken } from "../login";

export const getBranchAction = () => async (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  };
  dispatch({
    type: FETCH_BRANCH_REQUEST,
    payload: [],
  });
  try {
    const response = await api.get("branch", config);
    const { status, data } = response;

    if (status == 200) {
      dispatch({
        type: FETCH_BRANCH_SUCCESS,
        payload: data,
      });
    }
  } catch (error) {
    if(error.response.status==401){
      localStorage.removeItem("token");
    }
    dispatch({
      type: FETCH_BRANCH_FAIL,
      payload: [],
    });
  }
};
